import React from "react";
import { usePage } from "@inertiajs/react";
import Header from "@components/header";
import Layout from "@components/layout";
import Stepper from "./stepper";
import useTranslation from "@hooks/use_translation";

import "./onboarding_layout.scss";

const OnboardingLayout = ({ children }: { children: React.ReactNode }) => {
  const { stepper } = usePage<{ stepper?: { currentStep: number } }>().props;
  const { t } = useTranslation("onboarding", { keyPrefix: "steps" });

  const steps = [{ label: t("resume") }, { label: t("application") }, { label: t("complete") }];

  return (
    <Layout publicFacing>
      <div className="onboarding">
        <Header minimal />
        {stepper && <Stepper steps={steps} currentStep={stepper.currentStep} />}
        <main className="onboarding__content">{children}</main>
      </div>
    </Layout>
  );
};

export default OnboardingLayout;
